(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('MessagesPortalReportController', messagesPortalReportController)

  messagesPortalReportController.inject = ['$rootScope', '$http', 'NotificationService', 'MessagesPortalReportService', 'SMSService', 'SectorService', 'MessagesPortalTemplateService']

  function messagesPortalReportController ($rootScope, $http, NotificationService, MessagesPortalReportService, SMSService, SectorService, MessagesPortalTemplateService) {
    $rootScope.getPageLabels('menu.messagesPortal.messagesReport');

    var vm = this;

    vm.search = search;
    vm.download = download;
    vm.dateSelected = dateSelected;
    vm.deleteFiltersForEmail = deleteFiltersForEmail;
    vm.total = 100;
    vm.sendingChannelType = '-1';
    vm.loadData = loadData;
    vm.allChannels = [];

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    function loadData () {
      vm.filters.sendingChannelType = vm.sendingChannelType;
      if (vm.allChannels && vm.sectors) {
        vm.channels = vm.allChannels.channelsSms;
        if (vm.sendingChannelType == 'waent') {
          vm.channels = vm.allChannels.channelsWaent;
        }
        return false;
      }
      MessagesPortalTemplateService
        .getChannelsWaentSms()
        .$promise
        .then(function (data) {
          vm.allChannels = data;
          vm.channels = vm.allChannels.channelsSms;
          if (vm.sendingChannelType == 'waent') {
            vm.channels = vm.allChannels.channelsWaent;
          }
        })
        .catch(function () {
          NotificationService.errorHandler(vm, vm.labels.errorLoadingChannel);
        });

      SectorService
        .loadSectorsByUser()
        .$promise
        .then(function (data) {
          vm.sectors = data;
        })
        .catch(function () {
          NotificationService.errorHandler(data, $rootScope.labels.errorLoadSectors);
        });
    }

    function search () {
      if (validateFields()) {
        MessagesPortalReportService
          .getMessagesPortal(vm.filters)
          .$promise
          .then(function (data) {
            if (data.success) {
              vm.show = true;
              vm.channel = data.report.channels;
              vm.promoter = data.report.promoters;
              vm.sent = data.report.countSent;
              vm.success = data.report.countSuccess;
              vm.answered = data.report.countAnswered;
              vm.answeredPercent = calcPercent(data.report.countAnswered, data.report.countSent);
              vm.successPercent = calcPercent(data.report.countSuccess, data.report.countSent);
            } else {
              vm.show = false;
              NotificationService.warningHandler(data, data.message);
            }
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $rootScope.labels.errorLoadInfo);
          })
      }
    };

    function dateSelected (type, date) {
      if (type == 'from') { vm.pkadayToDate.setMinDate(date); }
      if (type == 'to') { vm.pkadayFromDate.setMaxDate(date); }
    };

    function validateFields () {
      var messagesPortalValidRoles = [3, 4];
      if (messagesPortalValidRoles.indexOf($rootScope.user_data.role) != -1 && vm.filters.receiving_sector_id == undefined) { // Gerente, Supervisor do Portal de SMS
        NotificationService.warningHandler('', $rootScope.labels.selectASector);
        return false;
      }
      var toDate = moment(vm.filters.toDate, 'DD/MM/YYYY');
      var fromDate = moment(vm.filters.fromDate, 'DD/MM/YYYY');
      if (toDate < fromDate) {
        NotificationService.warningHandler('', $rootScope.labels.invalidInitialDate);
        vm.show = false;
        return false;
      }
      if (toDate.diff(fromDate, 'days') > 30) {
        vm.show = false;
        NotificationService.warningHandler('', $rootScope.labels.maxPeriod30Days);
        return false;
      }
      return true;
    }

    function calcPercent (value, total) {
      value = ((value * 100) / total).toFixed(2);
      if (isNaN(value)) { return 0; }
      return value;
    }

    function download () {
      if (validateFields()) {
        $http.get(apiUrl + '/reports/common/MessagesPortal', {
          params: {
            filters: vm.filters
          }
        })
          .then(function ({ data, status, headers }) {
            if (data.success === false) {
              NotificationService.errorHandler(data, data.message);
              return;
            }

            var filename = headers('Mktzap-Filename');

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' });
            angular.element(document.body).append(anchor);

            var blob = new Blob([data], { type: 'text/csv' });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove();
            URL.revokeObjectURL(csvUrl);
          }, function () {
            vm.filters.sendByEmail = true;
            vm.filters.typeReport = 10;
            vm.filters.reportTitle = $rootScope.labels.title;
            vm.filters.extraParams = {};
            if (vm.filters.phone) {
              vm.filters.extraParams.phone = vm.filters.phone;
            }
            if (vm.filters.sending_channel_id) {
              vm.filters.extraParams.sending_channel_id = vm.filters.sending_channel_id;
            }

            if (vm.filters.receiving_sector_id) {
              vm.filters.extraParams.receiving_sector_id = vm.filters.receiving_sector_id;
            }
            $http.get(apiUrl + '/reports/common/MessagesPortal', {
              params: {
                filters: vm.filters
              }
            })
              .then(function ({ data }) {
                if (data.success) {
                  NotificationService.warningHandler(data, $rootScope.labels.alertProcessMail);
                }
                deleteFiltersForEmail();
              }, function ({ data }) {
                NotificationService.errorHandler(data, $rootScope.labels.errorReport);
                deleteFiltersForEmail();
              })
          })
      }
    }

    function deleteFiltersForEmail () {
      delete vm.filters.sendByEmail;
      delete vm.filters.typeReport;
      delete vm.filters.reportTitle;
      delete vm.filters.extraParams;
    }
  }
})();
